<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="switchCoupon({ couponName: $t('common.all'), couponId: '' })"
              :class="{ 'selected': userCouponInfo.conditions.couponId === '' }">
              {{ $t('common.all') }}
            </li>
            <li v-for="(item, index) in userCouponInfo.coupons" :key="index"
              @click="switchCoupon(item)"
              :class="{ 'selected': userCouponInfo.conditions.couponId == item.couponId }">
              {{ item.couponName }}
            </li>
          </ul>
        </el-card>
      </el-col>
      <el-col :span="21">
        <el-card>
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('couponManage.queryCondition') }}</span>
          </div>
          <el-form :inline="true" class="demo-form-inline text-left">
            <el-form-item>
              <el-input v-model="userCouponInfo.conditions.userName"
                :placeholder="$t('couponManage.userName')" clearable style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-input v-model="userCouponInfo.conditions.tel"
                :placeholder="$t('couponManage.phoneNumber')" clearable style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryUserCouponMethod()">
                <i class="el-icon-search"></i> {{ $t('couponManage.query') }}
              </el-button>
              <el-button @click="_resetUserCouponMethod()">
                <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card style="margin-top: 20px;">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('couponManage.userCoupons') }}</span>
          </div>
          <el-table :data="userCouponInfo.userCoupons" border style="width:100%" v-loading="loading">
            <el-table-column prop="userCouponId" :label="$t('couponManage.id')" align="center" />
            <el-table-column prop="couponName" :label="$t('couponManage.couponName')" align="center" />
            <el-table-column prop="personName" :label="$t('couponManage.userName')" align="center" />
            <el-table-column prop="tel" :label="$t('couponManage.phoneNumber')" align="center" />
            <el-table-column prop="couponType" :label="$t('couponManage.couponType')" align="center">
              <template slot-scope="scope">
                {{ scope.row.couponType === '01' ? $t('couponManage.fullReduction') : $t('couponManage.discount') }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('couponManage.discountInfo')" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.couponType === '01'">
                  {{ $t('couponManage.reduce') }}￥{{ scope.row.discountAmount }}
                </span>
                <span v-else>
                  {{ scope.row.discountPercent }}%{{ $t('couponManage.off') }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="status" :label="$t('couponManage.status')" align="center">
              <template slot-scope="scope">
                {{ scope.row.status === '0' ? $t('couponManage.unused') : scope.row.status === '1' ? $t('couponManage.used') : $t('couponManage.expired') }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('couponManage.validTime')" align="center">
              <template slot-scope="scope">
                {{ scope.row.startTime }}~{{ scope.row.endTime }}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" :label="$t('couponManage.receiveTime')" align="center" />
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="userCouponInfo.conditions.page"
            :page-size="userCouponInfo.conditions.row" layout="total, prev, pager, next"
            :total="userCouponInfo.total" style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { listUserCoupon, listShopCoupon } from '@/api/coupon/couponApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'UserCouponManage',
  data() {
    return {
      loading: false,
      userCouponInfo: {
        userCoupons: [],
        coupons: [],
        total: 0,
        conditions: {
          userName: '',
          tel: '',
          couponId: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.userCouponInfo.conditions.shopId = getShopId()
    this._listCoupons()
    this._listUserCoupons()
  },
  methods: {
    async _listCoupons() {
      try {
        const res = await listShopCoupon({
          shopId: getShopId(),
          page: 1,
          row: 100
        })
        this.userCouponInfo.coupons = res.data || []
      } catch (error) {
        console.error('获取优惠券列表失败:', error)
      }
    },
    async _listUserCoupons() {
      this.loading = true
      try {
        const res = await listUserCoupon(this.userCouponInfo.conditions)
        this.userCouponInfo.userCoupons = res.data
        this.userCouponInfo.total = res.total
      } catch (error) {
        console.error('获取用户优惠券列表失败:', error)
      } finally {
        this.loading = false
      }
    },
    _queryUserCouponMethod() {
      this.userCouponInfo.conditions.page = 1
      this._listUserCoupons()
    },
    _resetUserCouponMethod() {
      this.userCouponInfo.conditions.userName = ''
      this.userCouponInfo.conditions.tel = ''
      this.userCouponInfo.conditions.page = 1
      this._listUserCoupons()
    },
    handleCurrentChange(val) {
      this.userCouponInfo.conditions.page = val
      this._listUserCoupons()
    },
    switchCoupon(coupon) {
      this.userCouponInfo.conditions.couponId = coupon.couponId || ''
      this.userCouponInfo.conditions.page = 1
      this._listUserCoupons()
    }
  }
}
</script>

<style scoped>
/* 使用 el-card 和全局 list-selector 样式，无需自定义样式 */
</style>

